import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { DASH } from "@/constants/testIds";

export default function KpiCard({ label, value, sub, trend, tid }) {
    const TrendIcon = trend > 0 ? TrendingUp : trend < 0 ? TrendingDown : Minus;
    const trendColor =
        trend > 0 ? "text-emerald-400" : trend < 0 ? "text-red-400" : "text-slate-400";

    return (
        <div
            data-testid={DASH.kpiCard(tid)}
            className="glass hover-lift rounded-xl p-5 relative overflow-hidden"
        >
            <div className="absolute top-0 left-0 h-[2px] w-10 bg-[var(--sgsb-gold)]" />
            <div className="kicker text-slate-400">{label}</div>
            <div className="mt-3 font-display font-black text-white text-3xl tracking-tighter">{value}</div>
            <div className="mt-2 flex items-center gap-2 text-xs font-body">
                {trend !== undefined && (
                    <span className={`inline-flex items-center gap-1 ${trendColor}`}>
                        <TrendIcon className="h-3 w-3" strokeWidth={2} />
                        {Math.abs(trend)}%
                    </span>
                )}
                {sub && <span className="text-slate-500">{sub}</span>}
            </div>
        </div>
    );
}
